export const blackListedCountryCodes = [
    'AL',
    'BB',
    'BF',
    'BI',
    'BW',
    'BY',
    'BU',
    'CF',
    'CU',
    'HT',
    'IQ',
    'IR',
    'JM',
    'KH',
    'KP',
    'KY',
    'LB',
    'LY',
    'MA',
    'ML',
    'MT',
    'MU',
    'NI',
    'PK',
    'RU',
    'SD',
    'SN',
    'SO',
    'SS',
    'SY',
    'UA',
    'UG',
    'VE',
    'YE',
    'ZW',
    'CD',
    'CG',
    'MM',
];

export const cargosprintPhoneNumber = '678-470-4708';

export const SPRINT_PAY_FLEX_SLOGAN = {
    full: `Release Now, Pay Later\u2122`,
    abbreviated: `RNPL\u2122`,
} as const;

export const userTypes = {
    REQUESTOR: 'requestor',
    APPROVER: 'approver',
    FINANCIE: 'financie',
    UNIQUE_REQUESTOR: 'unique_requestor',
};

export function buildSSORedirectUrl(redirectUrl: string, source: string): string {
    const isNewSSO = redirectUrl.includes('saml-sso');
    return isNewSSO ? `${redirectUrl}-${source}` : `${redirectUrl}?source=${source}`;
}
